import React from 'react';
import styled from 'styled-components';
import { Wordmark } from '../../../icons/Icons';
import { media } from '../../../components/style-utils';

export default function Header(props) {
  return (
    <Container>
      <HeaderWordmark />
    </Container>
  );
}

const Container = styled.div`
  padding-top: 3rem;
  padding-left: 3rem;
`;

const HeaderWordmark = styled(Wordmark)`
  display: block;
  width: auto;
  height: 4.5rem;
  text-align: center;
  z-index: 1;

  ${media.tabletLandscapeAndUp`
    width: auto;
    height: 5rem;
    margin-right: 1rem;
  `};
`;



// WEBPACK FOOTER //
// ./src/routes/ThankYou/components/Header.js